export default (state = [], action) => {
    if ('FETCH_FILTERS' === action.type) {
        return action.payload.groups;
    }

    return state;
};
